import { render, staticRenderFns } from "./ContentAnnotations.vue?vue&type=template&id=613f1e13"
import script from "./ContentAnnotations.vue?vue&type=script&lang=js"
export * from "./ContentAnnotations.vue?vue&type=script&lang=js"
import style0 from "./ContentAnnotations.vue?vue&type=style&index=0&id=613f1e13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports